import React from 'react';
import { XIcon } from 'lucide-react';
import { pains } from '../data/content';
import { Eyebrow, SectionLead, SectionTitle } from './ui/Section';
export function Pain() {
  return <section className="border-y border-line bg-white px-4 py-12 md:py-14" data-id="element-256" data-mp="1j1fzo57d7vx2">
      <div className="mx-auto max-w-4xl" data-id="element-257" data-mp="1j3so917mp4j3">
        <Eyebrow danger data-id="element-258" data-mp="1e3ei5opl84np">😤 La realidad</Eyebrow>
        <SectionTitle data-id="element-259" data-mp="1e4pl5mb7l8dr">
          ¿Querés empezar a correr pero no sabés{' '}
          <span className="text-accent" data-id="element-260" data-mp="1a2ktgt4bmltr">cuánto correr, cuándo descansar ni cómo avanzar?</span>
        </SectionTitle>
        <SectionLead data-id="element-261" data-mp="15901bhpesm2h">
          Un día corrés demasiado. Otro día no sabés si descansar. Buscás rutinas diferentes y
          terminás sin saber cuál seguir.
        </SectionLead>

        <div className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-262" data-mp="vdooj4xk9oxd">
          {pains.map(pain => <div key={pain} className="flex items-start gap-3 rounded-xl border border-line bg-canvas p-4" data-id="element-263" data-mp="qbqz1sykhxvz">
              <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" data-id="element-264" data-mp="1yx9mzr487fh0" />
              <span className="text-sm font-semibold text-slate-700 md:text-base" data-id="element-265" data-mp="1yvyfbg7ntnkm">{pain}</span>
            </div>)}
        </div>

        <div className="mt-8 rounded-2xl border-2 border-accent bg-canvas p-6 text-center md:p-8" data-id="element-266" data-mp="1ozd9wtrqaag9">
          <p className="text-lg font-black uppercase leading-tight text-ink md:text-2xl" data-id="element-267" data-mp="1txwxszpvtwb9">
            No necesitás otra rutina suelta. Necesitás saber qué hacer desde el día 1 hasta tu
            objetivo.
          </p>
          <p className="mx-auto mt-3 max-w-2xl text-sm font-semibold leading-relaxed text-slate-600 md:text-base" data-id="element-268" data-mp="2mlsu43bjhm7i">
            Combo Completo Running 2026 te da ese camino: identificás tu nivel, elegís tu objetivo y
            seguís la planificación correspondiente.
          </p>
        </div>
      </div>
    </section>;
}